function verificaModulo(codModuloVerificar, sistema = 2) {

    var context = JSON.parse(localStorage.getItem("context"));


    if (context == null)
        return false;

    var modulos = context.usuario.modulos;

    if (!modulos || modulos.length == 0)
        return false;

    var possui = false;
    modulos.forEach(item => {
        const partes = item.split("_");
        const codModulo = partes[0];
        const codSistema = partes[partes.length-1];

        if (codSistema === sistema.toString() && codModulo === codModuloVerificar.toString()) {
            possui = true;
        }
    });
    return possui;


}

export default verificaModulo;
